define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "configuration/properties",
  "./tenantInfoView",
  "modules/accountAdmin/tenantAdmin/tenantModel",
  "modules/accountAdmin/tenantAdmin/tenantAdminModal/tenantAdminModalModule",
], function (
  Backbone,
  Marionette,
  Messenger,
  Properties,
  TenantInfoView,
  TenantModel,
  TenantAdminModalModule,
) {
  var TenantInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tenantInfo";
      this.region = options.region;
      this.tenant = options.model;
      this._setUpVents();
    },
    show: function () {
      this.view = new TenantInfoView.tenantInfoLayout({ model: this.tenant });

      Messenger.onSave(function () {
        Messenger.saveAttempted(true);
      }, this);

      if (this.tenant.get("landlordId")) {
        this.tenant.landlord = Messenger.reqres.request(
          "fetch:landlord:id",
          this.tenant.get("landlordId"),
        );
      } else {
        this.tenant.landlord = new Backbone.Model();
      }

      this.tenant.isGlobalAdmin = Messenger.reqres.request("user:is:global:admin");
      this.tenant.isAdmin = Messenger.reqres.request("user:is:admin");
      // TODO - Add Landlord Admin : Edit only accessible by Tenant Admin, Landlord Admin, Global Admin

      this.tenant.showLandlord = Properties.showLandlords;

      this.tenant.landlord.onSynced(function () {
        this.showRegion(this.view);
      }, this);

      this.view.on(
        "edit:tenantSettings",
        function () {
          Messenger.vent.trigger(
            "show:modal",
            TenantAdminModalModule,
            {
              editMode: true,
            },
            this.tenant,
            {
              title: "admin.tenantAdmin.editTenant",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 550,
              trackInteraction: {
                action: "Edit Tenant",
                id: this.tenant.id,
                idType: "Tenant",
                object: "Tenant",
              },
            },
          );
        },
        this,
      );
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:tenant:profile:info",
        function () {
          Backbone.history.navigate(
            "accountAdmin/tenants/" + this.tenant.get("tenantId") + "/info",
          );
          this.show(this.tenant);
        },
        this,
      );
    },
  });

  return TenantInfoController;
});
